import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";

import type { InvoiceSearchResult, Transaction } from "@/apis/gql/types";
import {
  type InvoiceRowData,
  Table,
  useTableInstanceContext,
} from "@/components/shared/data-table";
import { GlobalFilterInput } from "@/components/shared/data-table/filters/inputs/global-filter";

type Props = {
  loading: boolean;
  transactions: Transaction[];
  onInvoicesSearchChange: (global: string) => void;
  invoicesSearch: string;
  hideHeader?: boolean;
};

export const InvoiceMatchingDataTable = ({
  loading,
  transactions,
  onInvoicesSearchChange,
  invoicesSearch,
  hideHeader = false,
}: Props) => {
  const { t } = useTranslation();
  const { table } = useTableInstanceContext<InvoiceSearchResult>();

  const tableRef = useRef(null);

  useEffect(() => {
    return () => {
      table.setFocusedRow(undefined);
    };
  }, [table]);

  return (
    <div className="flex flex-col gap-2 h-full">
      {!hideHeader && (
        <GlobalFilterInput
          placeholder={t(
            "transactions.search_panel.tabs.match.table.global_search.placeholder",
          )}
          value={invoicesSearch}
          onChange={onInvoicesSearchChange}
          autoFocus
          key={transactions.map((t) => t.bankTxnId).join(",")}
        />
      )}
      <Table
        loading={loading}
        ref={tableRef}
        className="border-none [&_thead_tr]:border-b [&_tbody_tr]:shadow-none [&_tbody_tr]:border-none [&_td]:py-0.5 [&_th]:py-0.5 [&_thead_tr]:mb-1"
        estimateSize={80}
        hideHeader={hideHeader}
      />
    </div>
  );
};
